export default "__VITE_ASSET__6b124602__"